import { createSlice } from "@reduxjs/toolkit";
import {
  fetchPlacesOfService,
  createPlaceOfService,
  updatePlaceOfService,
  deletePlaceOfService,
} from "../thunks/placeOfServiceThunk";

const initialState = {
  placesOfService: [],
  loading: false,
  error: null,
};

const placeOfServiceSlice = createSlice({
  name: "placeOfService",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch places of service
      .addCase(fetchPlacesOfService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlacesOfService.fulfilled, (state, action) => {
        state.loading = false;
        state.placesOfService = action.payload;
      })
      .addCase(fetchPlacesOfService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create place of service
      .addCase(createPlaceOfService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPlaceOfService.fulfilled, (state, action) => {
        state.loading = false;
        state.placesOfService.push(action.payload);
      })
      .addCase(createPlaceOfService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update place of service
      .addCase(updatePlaceOfService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePlaceOfService.fulfilled, (state, action) => {
        state.loading = false;
        state.placesOfService = state.placesOfService.map((pos) =>
          pos._id === action.payload._id ? action.payload : pos
        );
      })
      .addCase(updatePlaceOfService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete place of service
      .addCase(deletePlaceOfService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePlaceOfService.fulfilled, (state, action) => {
        state.loading = false;
        state.placesOfService = state.placesOfService.filter(
          (pos) => pos._id !== action.payload
        );
      })
      .addCase(deletePlaceOfService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default placeOfServiceSlice.reducer;
